const prefix = 'access-level';

export const i18n = {
    fullReadOnly: {
        id: `${prefix}.fullReadOnly`,
        defaultMessage: 'Full Read Only Access',
    },
    full: {
        id: `${prefix}.full`,
        defaultMessage: 'Full',
    },
    licensingReadOnly: {
        id: `${prefix}.licensingReadOnly`,
        defaultMessage: 'Licensing Read Only',
    },
    licensingEntitlements: {
        id: `${prefix}.licensingEntitlements`,
        defaultMessage: 'Licensing Entitlements',
    },
    supportReadOnly: {
        id: `${prefix}.supportReadOnly`,
        defaultMessage: 'Support Read Only',
    },
    supportEntitlements: {
        id: `${prefix}.supportEntitlements`,
        defaultMessage: 'Support Entitlements',
    },
    readOnly: {
        id: `${prefix}.readOnly`,
        defaultMessage: 'Read Only Access',
    },
} as const;
